const programs = [
	{
		path: '/agency/programs/list',
		name: 'agency-programs-list',
		component: () => import('@/views/agency/programs/list.vue'),
		meta: { layout: 'content', module: 'MGAG' },
	},
	{
		path: '/agency/programs/:id',
		name: 'agency-programs-detail',
		component: () => import('@/views/agency/programs/detail.vue'),
		meta: { layout: 'content', module: 'MGAG' },
	},
]

export default programs
